/* 手机专用响应式首页（仅 ≤767px 渲染;桌面仍用 Pencil 设计）
 * 由 nav.js 在 home 路由且 isNarrow() 时调用 window.LN_HOME_M.render(lang) 注入,不经 fit() 缩放。
 * 单列流式布局,内容取真实产品线路,四语(ja/ko 回退 en)。 */
window.LN_HOME_M = (function () {
  'use strict';
  var WA = '8613316423196';
  var SANS = { en: "system-ui,-apple-system,'Segoe UI',sans-serif", cn: "'Noto Sans SC',system-ui,sans-serif", ja: "'Noto Sans JP',system-ui,sans-serif", ko: "'Noto Sans KR',system-ui,sans-serif" };
  var SERIF = { en: "'Playfair Display',Georgia,serif", cn: "'Noto Serif SC',serif", ja: "'Noto Serif JP',serif", ko: "'Noto Serif KR',serif" };
  function ph(slug, w) { return 'https://images.unsplash.com/' + slug + '?fm=jpg&q=80&w=' + (w || 800); }
  var HERO = ph('photo-1779437651162-f1e4d269dd63', 1200);
  var IMG_GX_REGION = ph('photo-1710788206590-a8bbd6007e12');   // 区域卡(海岛/山水)
  var IMG_GZ_REGION = ph('photo-1771860471118-e76acda1257b');   // 区域卡(广州城市)

  // 真实线路(与列表页各卡图一致,互不重复)
  var GX = [
    { route: 'liting', img: ph('photo-1707299452840-749704261605'), cn: ['漓境纯美 · 桂林 4 日', '漓江精华 · 阳朔田园 · 纯玩不进店', '¥3,600'], en: ['Li River & Yangshuo Essence · 4-Day', "The Li River's finest, at an easy pace", '$520'] },
    { route: 'guilong', img: ph('photo-1703817856407-d49bd9916a86'), cn: ['桂龙山水记 · 桂林 5 日深度', '龙脊梯田 · 漓江竹筏 · 银子岩', '¥4,480'], en: ['Guilin in Depth · 5-Day', 'Longji terraces, Li River rafts & caves', '$640'] },
    { route: 'liyu', img: ph('photo-1773393877739-d98f73d131e2'), cn: ['漓遇阳朔 · 4 天 3 晚高端臻享', '天龙湾曼悦 + 阳朔万枫 Fairfield', '¥3,180'], en: ['Liyu Yangshuo · 4-Day Premium', 'Tianlong Bay Manyue + Fairfield by Marriott', '$460'] },
    { route: 'jinpin', img: ph('photo-1779437651162-f1e4d269dd63'), cn: ['金品桂林 · 4 日全景之旅', '大漓江船 · 遇龙河竹筏 · 银子岩', '¥1,880'], en: ['Jinpin Guilin · 4-Day Panorama', 'Li River cruise, Yulong raft & Silver Cave', '$270'] }
  ];
  var GZ = [
    { route: 'yangcheng', img: ph('photo-1759020480417-7da5ae8b861a'), cn: ['羊城风华 · 广府 3 天 2 晚', '花城地标 · 岭南工艺 · 老广美食', '¥1,280'], en: ['Canton in Bloom · 3-Day', 'City icons, Lingnan craft & Cantonese food', '$185'] },
    { route: 'gftour', img: ph('photo-1764694880117-f3ba7ace8ea6'), cn: ['广佛寻迹 · 广佛 4 天 3 晚', '广州地标 + 佛山祖庙 · 醒狮武魂', '¥1,880'], en: ['Guangzhou & Foshan · 4-Day', 'City icons + Foshan temple & lion dance', '$270'] }
  ];

  var T = {
    cn: {
      nav: [['首页', 'home'], ['广西', 'guangxi'], ['广州', 'guangfo'], ['定制', 'dingzhi'], ['攻略', 'stories'], ['关于', 'about']],
      eyebrow: '广西 · 广州 · 佛山', title: '发现华南的灵魂',
      sub: '桂林山水与广府烟火的私家小包团——不扎堆、不进店,一支属于你的本地团队。',
      cta1: '浏览线路', cta2: '联系规划师',
      badges: [['持证经营', '旅行社许可证 L-GD02590'], ['纯玩不进店', '写进每一份合同'], ['2–8 人小团', '绝不与陌生人拼团'], ['灵活可退', '出发前 7 天免费改期']],
      whyEye: '为什么选岭南漫游', whyTitle: '我们不卖团,我们打磨你会讲很久的旅程。',
      whyBody: '生长在桂林峰林与广府茶楼之间,行程的每一步都由我们自己掌控——设计它的规划师、陪你走的向导、送你回家的司机。无外包、无回扣、绝无购物绕路。',
      stats: [['8 年', '深耕华南'], ['3,000+', '私家接待旅客'], ['4.97/5', '平均行程评分']],
      flagEye: '旗舰 · 广州 + 广西', flagTitle: '两省,一场无缝之旅', flagSub: '7 天 6 晚 · 广州到桂林高铁串联 · 全程不进购物店', flagBtn: '看 7 天行程',
      regEye: '两个世界,一次旅程', regTitle: '你的故事从哪里开始?',
      gxName: '广西', gxDesc: '漓江竹筏、阳朔峰林、龙脊梯田——山水甲天下。', gxMeta: '4 条精选线路 · 低至 ¥1,880/人',
      gzName: '广州 · 佛山', gzDesc: '早茶、街头米其林、咏春功夫、祖庙醒狮。', gzMeta: '广府文化线路 · 低至 ¥1,280/人',
      gxTours: '广西 · 精选私家线路', gzTours: '广州 · 广府文化线路', viewAll: '查看全部', detail: '查看行程',
      ctaTitle: '把华南,走成你自己的故事', ctaSub: '免费定制 · 满意前不付款', ctaBtn: '免费定制行程', waBtn: 'WhatsApp 咨询',
      footNote: '岭南漫游 · 智选假日(深圳)国际旅行社有限公司 · L-GD02590'
    },
    en: {
      nav: [['Home', 'home'], ['Guangxi', 'guangxi'], ['Guangzhou', 'guangfo'], ['Tailor', 'dingzhi'], ['Guides', 'stories'], ['About', 'about']],
      eyebrow: 'GUANGXI · GUANGZHOU · FOSHAN', title: 'Discover the Soul of South China',
      sub: "Hand-crafted private journeys through Guilin's rivers and Canton's living heritage — no crowds, no shopping stops, your own local team.",
      cta1: 'Explore tours', cta2: 'Meet your designer',
      badges: [['Licensed operator', 'License L-GD02590'], ['Zero shopping stops', 'Written into every contract'], ['Private groups of 2–8', 'Never merged with strangers'], ['Flexible & refundable', 'Free changes up to 7 days']],
      whyEye: 'WHY LINGNAN JOURNEYS', whyTitle: "We don't sell tours. We craft the journey you'll tell stories about.",
      whyBody: "Born between Guilin's karst peaks and Canton's teahouses, we own every step — the planners who design it, the guides who walk beside you, the drivers who take you home. No subcontractors. No commissions. No shopping detours, ever.",
      stats: [['8 yrs', 'On the ground in South China'], ['3,000+', 'Travelers hosted privately'], ['4.97/5', 'Average trip rating']],
      flagEye: 'FLAGSHIP · GUANGZHOU + GUANGXI', flagTitle: 'Two provinces, one seamless journey', flagSub: '7 days / 6 nights · Guangzhou to Guilin by high-speed rail · no compulsory shopping', flagBtn: 'See the 7-day journey',
      regEye: 'TWO WORLDS, ONE JOURNEY', regTitle: 'Where will your story begin?',
      gxName: 'Guangxi', gxDesc: 'Li River rafts, Yangshuo peaks and Longji terraces — landscapes without equal.', gxMeta: '4 signature tours · from $270 pp',
      gzName: 'Guangzhou & Foshan', gzDesc: 'Yum cha, street Michelin, Wing Chun kung fu and ancestral temples.', gzMeta: 'Cantonese culture tours · from $185 pp',
      gxTours: 'Guangxi · signature private tours', gzTours: 'Guangzhou · Cantonese culture tours', viewAll: 'View all', detail: 'View itinerary',
      ctaTitle: 'Walk South China into your own story', ctaSub: 'Free itinerary design · no payment until you love it', ctaBtn: 'Design my trip — free', waBtn: 'Chat on WhatsApp',
      footNote: 'Lingnan Journeys · Zhixuan Holiday (Shenzhen) Intl Travel Service · L-GD02590'
    }
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function tourCard(item, lang, f) {
    var d = item[lang] || item.en;
    return '<a href="#' + item.route + '" style="display:block;background:#fff;border:1px solid #EAE2D8;border-radius:16px;overflow:hidden;text-decoration:none;box-shadow:0 4px 14px rgba(0,0,0,.05)">' +
      '<div style="height:180px;background:linear-gradient(180deg,#0000,#0000000f),url(\'' + item.img + '\');background-size:cover;background-position:center"></div>' +
      '<div style="padding:16px 18px 18px">' +
        '<div style="font:700 17px/1.3 ' + f.serif + ';color:#231F1D">' + esc(d[0]) + '</div>' +
        '<div style="font:400 13px/1.6 ' + f.sans + ';color:#6B625B;margin-top:6px">' + esc(d[1]) + '</div>' +
        '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:14px">' +
          '<div style="font:700 18px/1 ' + f.sans + ';color:#B01722">' + esc(d[2]) + ' <span style="font-weight:400;font-size:12px;color:#8A7F76">/ ' + (lang === 'cn' ? '人' : 'pp') + '</span></div>' +
          '<span style="font:700 13px/1 ' + f.sans + ';color:#231F1D;border:1px solid #E3DACD;padding:9px 14px;border-radius:9999px">' + esc(T[lang].detail) + ' →</span>' +
        '</div>' +
      '</div></a>';
  }

  function fpick(lang) { return { sans: SANS[lang] || SANS.en, serif: SERIF[lang] || SERIF.en }; }
  function lnorm(lang) { return (lang === 'cn' || lang === 'en') ? lang : 'en'; }   // ja/ko 回退 en

  // 公用移动页头(logo + 横向 chip 导航),供首页/详情/列表页复用
  function header(lang) {
    lang = lnorm(lang);
    var t = T[lang], f = fpick(lang), logo = window.LN_LOGO_URL || '', P = 'padding:0 20px';
    var nav = t.nav.map(function (n) {
      return '<a href="#' + n[1] + '" style="flex:0 0 auto;font:600 13px/1 ' + f.sans + ';color:#231F1D;text-decoration:none;padding:8px 14px;border:1px solid #EAE2D8;border-radius:9999px;background:#fff">' + esc(n[0]) + '</a>';
    }).join('');
    return '<header style="position:sticky;top:0;z-index:50;background:rgba(255,255,255,.96);backdrop-filter:blur(8px);border-bottom:1px solid #EFE7DA">' +
      '<div style="display:flex;align-items:center;gap:10px;' + P + ';height:56px">' +
        (logo ? '<img src="' + logo + '" alt="岭南漫游" style="height:34px;width:auto">' : '') +
        '<a href="#home" style="text-decoration:none;font:700 16px/1 ' + f.serif + ';color:#231F1D">Lingnan Journeys</a>' +
        '<span data-ln-lang-slot style="margin-left:auto;flex:0 0 auto"></span>' +   // 语言下拉注入此处
      '</div>' +
      '<div style="display:flex;gap:8px;overflow-x:auto;' + P + ';padding-bottom:10px;-webkit-overflow-scrolling:touch">' + nav + '</div>' +
    '</header>';
  }
  // 公用移动页脚
  function footer(lang) {
    lang = lnorm(lang);
    var t = T[lang], f = fpick(lang);
    return '<footer style="background:#231F1D;padding:28px 20px 40px">' +
      '<div style="font:700 16px/1.3 ' + f.serif + ';color:#fff">岭南漫游 Lingnan Journeys</div>' +
      '<div style="font:400 12px/1.7 ' + f.sans + ';color:#9c928a;margin-top:10px">' + esc(t.footNote) + '</div>' +
      '<div style="font:400 12px/1.7 ' + f.sans + ';color:#9c928a;margin-top:4px">yetiandi711@gmail.com · +86 133 1642 3196</div>' +
    '</footer>';
  }
  // 详情/关于/7天/行程等 renderFramed 页面的移动壳:页头 + 内容(免缩放,收窄留白由 CSS) + 页脚
  function frame(lang, mid) { return header(lang) + '<div data-ln-mobile-framed>' + (mid || '') + '</div>' + footer(lang); }
  // 广西/广州列表页的移动版:页头 + 线路卡 + CTA + 页脚
  function listing(lang, region, topHtml) {
    lang = lnorm(lang);
    var t = T[lang], f = fpick(lang);
    var isGz = region === 'guangfo';
    return header(lang) + (topHtml || '') + '<div data-ln-mobile-framed>' +
      section(isGz ? t.gzTours : t.gxTours, isGz ? GZ : GX, lang, f, region, t.viewAll) +
      '<section style="background:#B01722;padding:44px 20px;text-align:center">' +
        '<h2 style="font:700 24px/1.25 ' + f.serif + ';color:#fff;margin:0">' + esc(t.ctaTitle) + '</h2>' +
        '<p style="font:400 14px/1.6 ' + f.sans + ';color:#FFD9CF;margin:12px 0 20px">' + esc(t.ctaSub) + '</p>' +
        '<a href="#dingzhi" style="display:block;background:#fff;color:#B01722;font:700 16px/1 ' + f.sans + ';padding:16px;border-radius:9999px;text-decoration:none">' + esc(t.ctaBtn) + '</a>' +
      '</section>' +
    '</div>' + footer(lang);
  }

  function render(lang) {
    lang = lnorm(lang);
    var t = T[lang], f = fpick(lang);
    var wa = 'https://wa.me/' + WA;
    var P = 'padding:0 20px';  // 统一横向留白

    return '' +
    header(lang) +

    // 英雄区
    '<section style="position:relative;min-height:78vh;display:flex;align-items:flex-end;background:linear-gradient(180deg,#1a120f33,#1a120fdd),url(\'' + HERO + '\');background-size:cover;background-position:center">' +
      '<div style="' + P + ';padding-bottom:38px;color:#fff">' +
        '<div style="font:700 11px/1.4 ' + f.sans + ';letter-spacing:3px;color:#F0C88C">' + esc(t.eyebrow) + '</div>' +
        '<h1 style="font:700 40px/1.12 ' + f.serif + ';margin:12px 0 0">' + esc(t.title) + '</h1>' +
        '<p style="font:400 15px/1.65 ' + f.sans + ';color:#EbE1d6;margin:14px 0 22px">' + esc(t.sub) + '</p>' +
        '<a href="#guangxi" style="display:block;text-align:center;background:#B01722;color:#fff;font:700 16px/1 ' + f.sans + ';padding:16px;border-radius:9999px;text-decoration:none">' + esc(t.cta1) + '</a>' +
        '<a href="#about" style="display:block;text-align:center;background:transparent;color:#fff;border:1px solid #ffffff88;font:700 16px/1 ' + f.sans + ';padding:15px;border-radius:9999px;text-decoration:none;margin-top:10px">' + esc(t.cta2) + '</a>' +
      '</div>' +
    '</section>' +

    // 信任徽章
    '<section style="background:#FAF7F2;' + P + ';padding-top:24px;padding-bottom:24px">' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:14px">' +
        t.badges.map(function (b) {
          return '<div><div style="font:700 13px/1.3 ' + f.sans + ';color:#231F1D">' + esc(b[0]) + '</div>' +
            '<div style="font:400 11.5px/1.5 ' + f.sans + ';color:#8A7F76;margin-top:3px">' + esc(b[1]) + '</div></div>';
        }).join('') +
      '</div>' +
    '</section>' +

    // 为什么选我们 + 数据
    '<section style="background:#fff;' + P + ';padding-top:40px;padding-bottom:40px">' +
      '<div style="font:700 11px/1.4 ' + f.sans + ';letter-spacing:2px;color:#B01722">' + esc(t.whyEye) + '</div>' +
      '<h2 style="font:700 26px/1.25 ' + f.serif + ';color:#231F1D;margin:12px 0 14px">' + esc(t.whyTitle) + '</h2>' +
      '<p style="font:400 14px/1.75 ' + f.sans + ';color:#5c534c;margin:0">' + esc(t.whyBody) + '</p>' +
      '<div style="display:flex;gap:14px;margin-top:26px">' +
        t.stats.map(function (s) {
          return '<div style="flex:1"><div style="font:700 22px/1 ' + f.serif + ';color:#B01722">' + esc(s[0]) + '</div>' +
            '<div style="font:400 11px/1.4 ' + f.sans + ';color:#8A7F76;margin-top:6px">' + esc(s[1]) + '</div></div>';
        }).join('') +
      '</div>' +
    '</section>' +

    // 7 天旗舰横幅
    '<a href="#sc7d" style="display:block;text-decoration:none;background:#204A43;' + P + ';padding-top:30px;padding-bottom:30px">' +
      '<div style="font:700 10.5px/1.4 ' + f.sans + ';letter-spacing:2px;color:#8FCBB9">' + esc(t.flagEye) + '</div>' +
      '<div style="font:700 22px/1.25 ' + f.serif + ';color:#fff;margin:8px 0 6px">' + esc(t.flagTitle) + '</div>' +
      '<div style="font:400 13px/1.6 ' + f.sans + ';color:#cfe5dd">' + esc(t.flagSub) + '</div>' +
      '<div style="display:inline-block;margin-top:16px;background:#fff;color:#204A43;font:700 14px/1 ' + f.sans + ';padding:12px 20px;border-radius:9999px">' + esc(t.flagBtn) + ' →</div>' +
    '</a>' +

    // 两大区域
    '<section style="background:#fff;' + P + ';padding-top:40px;padding-bottom:8px;text-align:center">' +
      '<div style="font:700 11px/1.4 ' + f.sans + ';letter-spacing:2px;color:#B01722">' + esc(t.regEye) + '</div>' +
      '<h2 style="font:700 26px/1.25 ' + f.serif + ';color:#231F1D;margin:10px 0 20px">' + esc(t.regTitle) + '</h2>' +
    '</section>' +
    '<section style="background:#fff;' + P + ';padding-bottom:8px;display:flex;flex-direction:column;gap:16px">' +
      regionCard(t.gxName, t.gxDesc, t.gxMeta, IMG_GX_REGION, 'guangxi', t.viewAll, f) +
      regionCard(t.gzName, t.gzDesc, t.gzMeta, IMG_GZ_REGION, 'guangfo', t.viewAll, f) +
    '</section>' +

    // 广西线路
    section(t.gxTours, GX, lang, f, 'guangxi', t.viewAll) +
    // 广州线路
    section(t.gzTours, GZ, lang, f, 'guangfo', t.viewAll) +

    // 最终 CTA
    '<section style="background:#B01722;' + P + ';padding-top:46px;padding-bottom:46px;text-align:center">' +
      '<h2 style="font:700 26px/1.25 ' + f.serif + ';color:#fff;margin:0">' + esc(t.ctaTitle) + '</h2>' +
      '<p style="font:400 14px/1.6 ' + f.sans + ';color:#FFD9CF;margin:12px 0 22px">' + esc(t.ctaSub) + '</p>' +
      '<a href="#dingzhi" style="display:block;background:#fff;color:#B01722;font:700 16px/1 ' + f.sans + ';padding:16px;border-radius:9999px;text-decoration:none">' + esc(t.ctaBtn) + '</a>' +
      '<a href="' + wa + '" target="_blank" rel="noopener" style="display:block;background:transparent;color:#fff;border:1px solid #ffffff88;font:700 16px/1 ' + f.sans + ';padding:15px;border-radius:9999px;text-decoration:none;margin-top:10px">' + esc(t.waBtn) + '</a>' +
    '</section>' +

    footer(lang);
  }

  function regionCard(name, desc, meta, img, route, viewAll, f) {
    return '<a href="#' + route + '" style="display:block;text-decoration:none;border-radius:18px;overflow:hidden;min-height:220px;position:relative;background:linear-gradient(180deg,#0000,#000000cc),url(\'' + img + '\');background-size:cover;background-position:center">' +
      '<div style="position:absolute;left:0;right:0;bottom:0;padding:20px">' +
        '<div style="font:700 22px/1.2 ' + f.serif + ';color:#fff">' + esc(name) + '</div>' +
        '<div style="font:400 12.5px/1.55 ' + f.sans + ';color:#eee;margin-top:6px">' + esc(desc) + '</div>' +
        '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:12px">' +
          '<span style="font:600 11.5px/1.3 ' + f.sans + ';color:#F0C88C">' + esc(meta) + '</span>' +
          '<span style="font:700 12px/1 ' + f.sans + ';color:#231F1D;background:#fff;padding:9px 14px;border-radius:9999px">' + esc(viewAll) + ' →</span>' +
        '</div>' +
      '</div></a>';
  }

  function section(title, items, lang, f, route, viewAll) {
    return '<section style="background:#FAF7F2;padding:40px 20px">' +
      '<div style="display:flex;align-items:baseline;justify-content:space-between;margin-bottom:18px">' +
        '<h2 style="font:700 20px/1.25 ' + f.serif + ';color:#231F1D;margin:0;max-width:70%">' + esc(title) + '</h2>' +
        '<a href="#' + route + '" style="flex:0 0 auto;font:700 13px/1 ' + f.sans + ';color:#B01722;text-decoration:none">' + esc(viewAll) + ' →</a>' +
      '</div>' +
      '<div style="display:flex;flex-direction:column;gap:16px">' +
        items.map(function (it) { return tourCard(it, lang, f); }).join('') +
      '</div>' +
    '</section>';
  }

  return { render: render, header: header, footer: footer, frame: frame, listing: listing };
})();
